import {
 Icon,
 Box,
 Flex,
 Text,
 useRadio,
 useRadioGroup,
 useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import { SlClose as disapproved, SlCheck as approved } from 'react-icons/sl';
import baseService from '../../services/base';
import { AttentionModal } from '../Modals';

const status = {
 disapproved: {
  color: '#EA582B',
  bg: '#FDEEEA',
  label: 'Reprovar',
  selected: 'Reprovado',
 },
 approved: {
  color: '#78C151',
  bg: '#F1F9EE',
  label: 'Aprovar',
  selected: 'Aprovado',
 },
};

function RadioCard(props) {
 const { getInputProps, getRadioProps } = useRadio(props);
 const input = getInputProps();
 const checkbox = getRadioProps();

 const isChecked = props.value === 'approved' ? status.approved : status.disapproved;

 return (
  <Box as='label'>
   <input {...input} />
   <Flex
    {...checkbox}
    cursor={props?.isDisabled ? 'not-allowed' : 'pointer'}
    bg='gray.100'
    borderRadius='41.667px'
    w='fit-content'
    height='40px'
    p='6.67px 12px'
    align='center'
    gap='8px'
    _checked={{
     width: 'fit-content',
     borderRadius: '66.6px',
     padding: '4px 12px',
     color: isChecked.color,
     bg: isChecked.bg,
    }}
   >
    <Icon as={props.children} width='22px' height='22px' />

    <Text as='span' fontSize='sm' fontWeight={600}>
     {props.isChecked ? isChecked.selected : isChecked.label}
    </Text>
   </Flex>
  </Box>
 );
}

export function CustomCheckbox({
 status,
 idQuestionResponse,
 mutate,
 adminView,
 displayBoth,
}) {
 const options = ['approved', 'disapproved'];

 const [selectedStatus, setSelectedStatus] = useState('');
 const [isSubmitting, setIsSubmitting] = useState(false);
 const { isOpen, onOpen, onClose } = useDisclosure();

 const { getRootProps, getRadioProps, setValue, isDisabled } = useRadioGroup({
  name: 'response_' + idQuestionResponse,
  defaultValue: status,
  onChange: (value) => {
   setSelectedStatus(value);
   onOpen();
  },
  isDisabled: status !== 'pending' || isSubmitting || adminView,
 });

 const group = getRootProps();

 async function handleConfirmation() {
  setIsSubmitting(true);
  try {
   await baseService.patch(`question-response/${idQuestionResponse}`, {
    status: selectedStatus.toUpperCase(),
   });
   mutate();
  } catch (err) {
   console.log('err', err);
  } finally {
   setIsSubmitting(false);
   onClose();
  }
 }

 function handleClose() {
  setSelectedStatus('pending');
  setValue('pending');
  onClose();
 }
 
 return adminView && status === 'pending' ? (
  <Flex
   bg='gray.100'
   borderRadius='41.667px'
   w='fit-content'
   height='40px'
   p='6.67px 12px'
   align='center'
   gap='8px'
   opacity={0.8}
  >
   <Text as='span' fontSize='sm' fontWeight={600}>
    Não avaliado
   </Text>
  </Flex>
 ) : (
  <>
   <Flex gap='12px' {...group}>
    {options.map((value) => {
     const radio = getRadioProps({ value });
     return status === value || status === 'pending' || displayBoth ? (
      <RadioCard key={value} value={value} isDisabled={isDisabled} {...radio}>
       {value === 'approved' ? approved : disapproved}
      </RadioCard>
     ) : null;
    })}
   </Flex>
   <AttentionModal
    isOpen={isOpen}
    onClose={handleClose}
    title='Deseja mesmo avaliar?'
    content='Ao confirmar você não poderá alterar a sua escolha.'
    isLoading={isSubmitting}
    submit={handleConfirmation}
    redType
   />
  </>
 );
}
